const CLOUD_SESSION_KEYS = ["moo_cloud_user", "moo_cloud_token"];
const LOCAL_SESSION_KEYS = ["moo_user", "moo_token"];

const isRemoteCloudHost = (hostname = "") => {
  const normalized = String(hostname || "").trim().toLowerCase();
  if (!normalized) return false;
  if (/^(10\.|127\.|192\.168\.|169\.254\.)/.test(normalized)) return false;
  const private172 = normalized.match(/^172\.(\d+)\./);
  if (private172 && Number(private172[1]) >= 16 && Number(private172[1]) <= 31) {
    return false;
  }
  return ![
    "localhost",
    "127.0.0.1",
    "0.0.0.0",
    "::1",
  ].includes(normalized) && !normalized.endsWith(".local") && !normalized.endsWith(".lan");
};

const clearInvalidCloudSession = (storage) => {
  if (!storage) return;
  const cloudToken = String(storage.getItem("moo_cloud_token") || "");
  const localToken = String(storage.getItem("moo_token") || "");
  CLOUD_SESSION_KEYS.forEach((key) => storage.removeItem(key));

  // CloudLogin duplique volontairement la session nominative dans les clés
  // attendues par l'interface Admin. Ne supprimer ces clés que si elles
  // représentent bien la même session cloud, afin de ne jamais déconnecter
  // une caisse locale ouverte dans un autre contexte.
  if (cloudToken && localToken === cloudToken) {
    LOCAL_SESSION_KEYS.forEach((key) => storage.removeItem(key));
  }
};

const buildCloudLoginUrl = ({ pathname = "/", search = "", hostname } = {}) => {
  const returnTo = `${pathname || "/"}${search || ""}`;
  const resolvedHostname = hostname ?? (
    typeof window !== "undefined" ? String(window.location?.hostname || "") : ""
  );
  // Les sous-domaines établissements utilisent toujours le parcours client
  // historique /login. /cloud/* est réservé au portail siège Djizef.
  const loginPath = getTenantSubdomain(resolvedHostname) ? "/login" : "/cloud/login";
  return `${loginPath}?returnTo=${encodeURIComponent(returnTo)}`;
};

const getTenantSubdomain = (hostname = "") => {
  const normalized = String(hostname || "").trim().toLowerCase();
  const parts = normalized.split(".").filter(Boolean);
  if (parts.length < 3 || parts[0] === "www") return "";
  return parts[0];
};

const isCloudSessionValidForHost = ({ hostname = "", user, token } = {}) => {
  if (!token || !user || typeof user !== "object") return false;
  const role = String(user.role || "").trim().toLowerCase();
  const tenantSubdomain = getTenantSubdomain(hostname);

  if (tenantSubdomain) {
    if (!["admin", "manager", "stockeur"].includes(role)) return false;
    return String(user.tenant_subdomain || "").trim().toLowerCase() === tenantSubdomain;
  }

  return role === "cloud-superadmin";
};

module.exports = {
  buildCloudLoginUrl,
  clearInvalidCloudSession,
  getTenantSubdomain,
  isRemoteCloudHost,
  isCloudSessionValidForHost,
};
